/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedDTO_RequestDTO_ } from '../models/PaginatedDTO_RequestDTO_'
import type { RequestDTO } from '../models/RequestDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenRequestsService {
    /**
     * Index
     * @returns PaginatedDTO_RequestDTO_ Successful Response
     * @throws ApiError
     */
    public static indexRequestsGet({
        page = 1,
        limit = 10,
        patientId,
        status,
        orderId,
        sort
    }: {
        /**
         * Page number for pagination, starting at 1
         */
        page?: number
        /**
         * Number of items per page, maximum 1000
         */
        limit?: number
        /**
         * Filter by patient_id
         */
        patientId?: string | null
        /**
         * Filter by status
         */
        status?: string | null
        /**
         * Filter by order_id
         */
        orderId?: string | null
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_RequestDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/requests',
            query: {
                page: page,
                limit: limit,
                patient_id: patientId,
                status: status,
                order_id: orderId,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Get
     * @returns RequestDTO Successful Response
     * @throws ApiError
     */
    public static getRequestsRequestIdGet({ requestId }: { requestId: string }): CancelablePromise<RequestDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/requests/{request_id}',
            path: {
                request_id: requestId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
